import React, { useState, useRef, useEffect } from 'react';
import JoditEditor from 'jodit-react';
import { useQuizFormContext } from '../../hooks/quiz-form-context'
import { Form } from 'antd';
import "./index.css"
import InputDescription from '../quiz-input-show-description/quiz-input-show-description'

const CustomEditor = ({ title,
    name,
    size = 'large',
    Error,
    description,
    indexKey,
    allInputOnchageHandler,
    anwerRequirements,
    questionTooltip }) => {
    const {
        formValues,
        allFormErrorsList,
        setFormValues,
        contentFullErrorMsg,
        setContentFulErrorMsg,
        getInputValues,
    } = useQuizFormContext();

    //TO RENDER DESCRIPTION OF INPUTS
    function ShowDescription(description) {
        return <InputDescription description={description} questionTooltip={questionTooltip} />;
    }

    //Storing error msg value in state
    useEffect(() => {
        if (Error) {
            setContentFulErrorMsg((prev) => ({ ...prev, [name]: Error }))
        }
    }, [Error])
    const [charCount, setCharCount] = useState(250);
    const editor = useRef(null);
    const [content, setContent] = useState();
    const [isReadOnly, setIsReadOnly] = useState(true);
    const config = {
        readonly: isReadOnly, // all options from https://xdsoft.net/jodit/docs/,
        limitChars: 250,
        placeholder: 'Please start typing...',
        disablePlugins: "powered-by-jodit",
        buttons: "bold,italic,underline,strikethrough,ul,ol,paragraph,lineHeight,copy,paste,selectall,table",
        cleanHTML: {
            denyTags: {
                script: true,
                img: true
            },
            allowTags: {
                p: true,
                b: true,
                strong: true,
                em: true,
                a: {
                    href: true
                },
                table: true,
                tbody: true,
                tr: true,
                td: true,
                th: true,
                h1: true,
                h2: true,
                h3: true,
                h4: true,
                br: true,
                li: true,
                ol: true,
                ul: true,
                pre: true,
                blockquote: true,
                u: true,
                s: true
            }
        },
        minHeight: '300px',
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        defaultActionOnPaste: "insert_only_text",
    }
    // const stripHtmlTags = (html) => {
    //     const doc = new DOMParser().parseFromString(html, 'text/html');
    //     return doc.body.textContent || "";
    // };
    // const countVisibleCharacters = (text) => {
    //     return text.replace(/\s+/g, '').length; // Remove all whitespace characters and count the length
    // };
    // const countCheck = (newContent) => {
    //     const plainText = stripHtmlTags(newContent);
    //     const visibleCharCount = countVisibleCharacters(plainText);
    //     setCharCount(250 - visibleCharCount)
    // }
    const handleChange = (newContent) => {
        setContent(newContent)
        allInputOnchageHandler(indexKey, title, name, newContent);
    }
    useEffect(() => {
        setContent(getInputValues(name, formValues)?.value || '');
    }, []);

    const handleReadOnlyToggle = () => {
        setIsReadOnly(prev => !prev);
    };
    return (
        <>
            <Form.Item
                label={description && ShowDescription(description)}
                name={name}
                className="textarea-input-label-container"
                required={Error ? true : false}
            >
                <button type="button" className="editBtn" onClick={handleReadOnlyToggle}>
                    {isReadOnly ? 'Edit' : 'Save'}
                </button>
                <JoditEditor
                    ref={editor}
                    value={content}
                    config={config}
                    tabIndex={1} // tabIndex of textarea
                    onBlur={newContent => handleChange(newContent)} // preferred to use only this option to update the content for performance reasons
                    onChange={newContent => { }}
                />
                <div className="char-count-container" >
                    <span style={{ color: charCount == 0 ? "red" : "" }}>Character limit: {charCount}</span>
                </div>
            </Form.Item>
            {allFormErrorsList[name] && <span className="error-message">{Error}</span>}

        </>

    );
};

export default CustomEditor